import React, { FC } from "react";

/** The AI sparkle used across the Mail page and compose window (V53). */
export const SparkleIcon: FC<{ size?: number; className?: string }> = ({
  size = 14,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox={"0 0 24 24"}
    fill={"currentColor"}
    className={className}
    style={{ flex: "none" }}
    aria-hidden={"true"}>
    <path
      d={
        "M11 2.5c.5 4.6 2.9 7 7.5 7.5-4.6.5-7 2.9-7.5 7.5-.5-4.6-2.9-7-7.5-7.5 4.6-.5 7-2.9 7.5-7.5Z"
      }
    />
    <path
      d={
        "M19 14c.25 2 1.25 3 3 3.25-1.75.25-2.75 1.25-3 3.25-.25-2-1.25-3-3-3.25 1.75-.25 2.75-1.25 3-3.25Z"
      }
    />
  </svg>
);

/** Purple gradient square with a sparkle (headings of AI cards). */
export const SparkleBadge: FC<{ size?: number }> = ({ size = 24 }) => (
  <span
    className={
      "inline-flex flex-none items-center justify-center rounded-[7px] text-white"
    }
    style={{
      width: size,
      height: size,
      background: "linear-gradient(135deg,#6B4EFF,#A35BFF)",
    }}>
    <SparkleIcon size={Math.round(size * 0.55)} />
  </span>
);
